import type { AccountsView } from "@nabla/api";
import { designCopy } from "../../design/copy.ts";
import { formatFreshness, saoPaulo } from "../../design/format/dates.ts";
import { shellCopy } from "../copy.ts";

export function lateReads(view: AccountsView, sourceName: string | undefined, now: number): string[] {
  const only = view.sources.length === 1;
  return view.late.map(({ source, since }) => {
    const read = view.sources.find((s) => s.source.id === source);
    const sales = read && (only ? (sourceName ?? designCopy.fonte[read.kind]) : read.source.label);
    const label = sales ?? designCopy.fonte.meta;
    return shellCopy.frescor.atrasado(label, formatFreshness(since, new Date(now).toISOString(), saoPaulo));
  });
}
